export default async function ready<T>(callback?: (() => T | Promise<T>) | T): Promise<T | void> {
   async function action(resolve: (value?: T | PromiseLike<T> | void) => void): Promise<void> {
      try {
         return typeof callback === 'function'
            ? resolve(await (callback as () => T | Promise<T>)())
            : resolve(callback)
      } catch (e) {
         console.error(e)
         return resolve()
      }
   }

   return document.readyState === "interactive" || document.readyState === "complete"
      ? action((value?: T | PromiseLike<T> | void) => Promise.resolve(value))
      : new Promise((resolve) => document.addEventListener("DOMContentLoaded", () => action(resolve)))
}
